<template>
  <div id="app">
    <NavbarDefault v-if="menuActive" class="layout" />

    <main
      class="content font-mind-force tracking-wider"
      :class="[menuActive == true ? 'mt-[8vh]' : 'mt-[0]']"
    >
      <router-view />
    </main>
  </div>
</template>

<script setup>
import NavbarDefault from "./components/NavbarDefault.vue";
import { computed, onMounted } from "vue";
import { globalStore } from "./store";

const menuActive = computed(() => globalStore.getters.getIfMenuActive);

onMounted(() => {
  checkAppVersion();
});

async function checkAppVersion() {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
    });

    const data = await response.json();
    const currentVersion = localStorage.getItem("app_version");

    if (!currentVersion) {
      localStorage.setItem("app_version", data.version);
      return;
    }

    if (currentVersion !== data.version) {
      localStorage.setItem("app_version", data.version);

      if ("caches" in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map((key) => caches.delete(key)));
      }

      window.location.reload();
    }
  } catch (error) {
    console.error("Erro ao verificar versão do app:", error);
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

::-webkit-scrollbar {
  width: 2px;
  height: 1px;
}

::-webkit-scrollbar-thumb {
  background-color: #000;
  border-radius: 2px;
}

::-webkit-scrollbar-track {
  background-color: #1b1e25;
  border-radius: 2px;
}
</style>
